import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { DeleteDeviceCollectionDocument } from './delete.generated';

export const useDeleteDeviceCollection = (
  options: ApiOptions<typeof DeleteDeviceCollectionDocument> = {},
) => {
  const { t } = useTranslation();
  return useMutation(DeleteDeviceCollectionDocument, {
    ...useNotifications(DeleteDeviceCollectionDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: t('api.device_filters.delete_success'),
    }),
    ...options,
  });
};
